module.exports = __webpack_public_path__ + "static/media/dry-aged-1.5ddfb770.jpg";